import { Doughnut } from "vue-chartjs";
export default {
    extends: Doughnut,
    props: ['labels','statistics','stat'],
    data() {
      return {
          chartData: {
              labels: this.$props.labels,
              statisticItem: this.$props.statistics,
              datasets: [
                  {
                      backgroundColor: ["#78bf8899","#f491ab99", "#00D8FF99"],
                      hoverBackgroundColor: ["#78bf88","#f491ab", "#00D8FF"],
                      hoverBorderWidth: 5,
                      hoverBorderColor: '#ffffff',
                      borderWidth: 10,
                      data: this.$props.stat,
                  }
              ]
          },
          chartOptions: {
              cutoutPercentage: 30,
              hoverBorderWidth: 20,
              legend: {
                  display: false,
                  position: 'top'
              }
          },
          afterDraw(chart, args, options) {
              const {datasets} = chart.data
              let hasData = false
              for (let dataset of datasets) {
                  if (dataset.data.length > 0 && dataset.data.some(item => item !== 0)) {
                      hasData = true;
                      break;
                  }
              }

              if (!hasData) {
                  this.emit({type: 'doughnut', isEmpty: true})
              } else {
                  this.emit({type: 'doughnut', isEmpty: false})
              }
          }
      }
    },
    async mounted() {
        this.addPlugin({id: 'emptyDoughnut', afterDraw: this.afterDraw, emit: (args) => this.$emit('empty-chart', args)})
        this.renderChart(this.chartData, this.chartOptions)
    }
};
